var exports = {
  "F": "x61f99309--c5d709--parameters",
  "W": "x61f99309--c5d709--parameter",
};

module.exports = exports;
